import { useEffect, useCallback } from 'react';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { AppUIActions } from 'app/store/AppUI/AppUI.slice';
// Selectors
import { selectFocusModeEnabled } from 'app/store/AppUI/AppUI.selectors';

const useFullscreenFocusMode = () => {
  const dispatch = useAppDispatch();
  const focusModeEnabled = useAppSelector(selectFocusModeEnabled);

  // Handle manual toggle (click)
  const handleClick = useCallback(() => {
    const element = document.documentElement;
    const isFullscreen = !document.fullscreenElement;

    const triggerMouseEnterAgain = () => {
      setTimeout(() => {
        const btn = document.querySelector('[data-action-button="focusMode"]') as HTMLElement | null;
        if (btn) {
          btn.blur();
          setTimeout(() => btn.focus(), 0);
        }
      }, 100);
    };

    if ( isFullscreen ) {
      element.requestFullscreen?.().then(() => {
        triggerMouseEnterAgain();
      });
    } else {
      document.exitFullscreen?.().then(() => {
        triggerMouseEnterAgain();
      });
    }

    dispatch(AppUIActions.setFocusMode(isFullscreen));
  }, [dispatch]);

  // Listen to system fullscreen changes (F11, Esc)
  useEffect(() => {
    const handleFullscreenChange = () => {
      const isFullscreen = !!document.fullscreenElement;
      if ( isFullscreen !== focusModeEnabled ){
        dispatch(AppUIActions.setFocusMode(isFullscreen));
      }
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, [dispatch, focusModeEnabled]);

  useEffect(() => {
    document.body.style.overflow = focusModeEnabled ? 'hidden' : 'initial';
  }, [focusModeEnabled])

  return { handleClick };
};

export default useFullscreenFocusMode;

